import React from "react";
import cl from "classnames";

export default function Tab({tab, changeTab}) {

  return (
    <ul className="lesson_tabs nav nav-tabs" >
      <li className="lesson_tab_item" >
        <button
          className={cl({
            active: tab === "lesson",
          })}
          onClick={() => changeTab("lesson")}
        >
          Урок
        </button>
      </li>
      <li className="lesson_tab_item">
        <button
          className={cl({
            active: tab === "discuss",
          })}
          onClick={() => changeTab("discuss")}
        >
          Обсуждение
        </button>
      </li>
    </ul>
  );
}
